/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import PropTypes from 'prop-types';
import AmbulantContainer from './ambulant/container/AmbulantContainer';
import CityEmployeeContainer from './city-employee/container/CityEmployeeContainer';
import ContractOfServiceContainer from './contract-of-service/container/ContractOfServiceContainer';
import MarketVendorContainer from './market-vendors/container/MarketVendorContainer';
import RenewContainer from './renew/container/RenewContainer';

function TabContainer({ match, pathName }) {
  const permissions = getJson('permissions');

  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              <li className="nav-item">
                <Link
                  to="/health-certificate/application/ambulant"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${pathName.indexOf(
                    '/health-certificate/application/ambulant'
                  ) > -1
                    ? 'selected'
                    : ''
                    }`}
                >
                  Ambulant
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/health-certificate/application/city-employee"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${pathName.indexOf(
                    '/health-certificate/application/city-employee'
                  ) > -1
                    ? 'selected'
                    : ''
                    }`}
                >
                  City Hall Employee
                </Link>
              </li>
              {Acl(permissions, ['VIEW HEALTH CERTIFICATE CONTRACT OF SERVICE']) && (
                <li className="nav-item">
                  <Link
                    to="/health-certificate/application/contract-of-service"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${pathName.indexOf(
                      '/health-certificate/application/contract-of-service'
                    ) > -1
                      ? 'selected'
                      : ''
                      }`}
                  >
                    Contract of Service
                  </Link>
                </li>
              )}
              {Acl(permissions, ['VIEW HEALTH CERTIFICATE MARKET VENDORS']) && (
                <li className="nav-item">
                  <Link
                    to="/health-certificate/application/market-vendors"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${pathName.indexOf(
                      '/health-certificate/application/market-vendors'
                    ) > -1
                      ? 'selected'
                      : ''
                      }`}
                  >
                    Market Vendors
                  </Link>
                </li>
              )}
              {Acl(permissions, ['VIEW HEALTH CERTIFICATE RENEW']) && (
                <li className="nav-item">
                  <Link
                    to="/health-certificate/application/renew"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${pathName.indexOf(
                      '/health-certificate/application/renew'
                    ) > -1
                      ? 'selected'
                      : ''
                      }`}
                  >
                    Renew
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/ambulant`} />}
          />
          <Route
            path={`${match.path}/ambulant`}
            component={AmbulantContainer}
          />
          <Route
            path={`${match.path}/city-employee`}
            component={CityEmployeeContainer}
          />
          {Acl(permissions, ['VIEW HEALTH CERTIFICATE CONTRACT OF SERVICE']) && (
            <Route
              path={`${match.path}/contract-of-service`}
              component={ContractOfServiceContainer}
            />
          )}
          {Acl(permissions, ['VIEW HEALTH CERTIFICATE MARKET VENDORS']) && (
            <Route
              path={`${match.path}/market-vendors`}
              component={MarketVendorContainer}
            />
          )}
          {Acl(permissions, ['VIEW HEALTH CERTIFICATE RENEW']) && (
            <Route
              path={`${match.path}/renew`}
              component={RenewContainer}
            />
          )}
        </Switch>
      </div>
    </React.Fragment>
  );
}

TabContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(TabContainer);
